import { BrandConfig } from '../types'

export const justOnlyConfig: BrandConfig = {
  // アプリケーション基本情報
  appName: 'PINTO 4 YOU',
  appUrl: 'https://pintoforyou.com',
  hashtag: 'p4you',
  metaDescription: '先着4名まで、あなたの推しからの特別なメッセージを受け取ることができるサービス。写真や動画などのデジタルコンテンツにてお届けしますので、スマホでいつでも閲覧可能、推しをより身近に感じることができます。',
  
  // お問い合わせ・サポートURL
  contactUrl: 'https://tayori.com/form/4522f209bb45dafdf271db5e279ef0c9fbb0227c',
  userFaqUrl: 'https://pintoforyou.tayori.com/faq/00071060f7d33cfe5cfe0f42f7ba2991357c0660',
  creatorAndBusinessFaqUrl: 'https://pintoforyou.tayori.com/faq/a8d84a3ceb31dddad83e7324d31522342921b55f',
  creatorRegistrationUrl: 'https://pintoforyou.tayori.com/form/245f46710a9a64b0c6371508dd3e9d38dcc263d6',
  creatorBankAccountRegistrationUrl: 'https://pintoforyou.tayori.com/form/ee965284e2b88fd977e9c9add0e31d696fb88425',
  
  // ソーシャルメディアURL
  socialTwitterUrl: 'https://twitter.com/p4you_jp',
  socialFacebookUrl: '',
  socialInstagramUrl: 'https://www.instagram.com/p4you_jp/',
  socialYoutubeUrl: '',
  
  // ブランド固有の設定
  primaryColor: '#81cac4',
  secondaryColor: '#ca8194',
}
